import React from 'react';
import PropTypes from 'prop-types';
import Actions from 'components/ui/general/Actions';
import Breadcrumbs from 'components/layout/Layout/Breadcrumbs';
import Card from 'components/ui/card/Card';
import CardText from 'components/ui/card/CardText';
import Header from 'components/ui/general/Header';
import ListButton from 'components/button/ListButton';
import LoadingCard from 'components/loading/LoadingCard';
import ResourceNotFound from 'pages/NotFound/ResourceNotFound';
import Title from 'components/ui/general/Title';
import UsersEditForm from './UsersEditForm';
import compose from 'recompose/compose';
import fetchResourceById from 'components/hoc/fetchResourceById';
import translate from 'components/hoc/translate';
import utils from 'helpers/utils';
import { connect } from 'react-redux';
import { fetchUser } from 'store/actions/users/fetchUsers';
import { updateUser } from 'store/actions/users/updateUsers';

class UsersEditContainer extends React.Component {
    handleSubmitForm = (values) => {
        const {
            dispatchForm,
            history,
            id,
        } = this.props;

        return new Promise((resolve) => {
            dispatchForm({
                onError: () => {
                    resolve();
                },
                onSuccess: (response) => {
                    const {
                        id,
                    } = response;

                    resolve(history.push(`/users/${ id }/show`));
                },
                values: values,
                id: id,
            });
        });
    }

    render() {
        const {
            data,
            resource,
            resourceFetchFailed,
            resourceFetchLoading,
            translate,
        } = this.props;

        if (resourceFetchLoading) {
            return <LoadingCard />;
        }

        if (resourceFetchFailed) {
            return <ResourceNotFound />;
        }

        const breadcrumbs = [
            {
                label: translate('resources.users.title'),
                link: '/users',
            },
            {
                label: utils.fullName(data.first_name, data.last_name),
                link: `/users/${ data.id }/show`,
            },
            {
                label: translate('actions.edit'),
            },
        ];

        return (
            <div>
                <Breadcrumbs breadcrumbs={ breadcrumbs } />

                <Header>
                    <Title title={ translate('resources.users.actions.edit') } />

                    <Actions>
                        <ListButton url='/users' />
                    </Actions>
                </Header>

                <Card>
                    <CardText>
                        <UsersEditForm
                            data={ data }
                            form='users_edit'
                            handleSubmitForm={ this.handleSubmitForm }
                            resource={ resource }
                        />
                    </CardText>
                </Card>
            </div>
        );
    }
}

UsersEditContainer.propTypes = {
    data: PropTypes.object,
    dispatchForm: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    id: PropTypes.number,
    resource: PropTypes.string,
    resourceFetchFailed: PropTypes.bool.isRequired,
    resourceFetchLoading: PropTypes.bool.isRequired,
    translate: PropTypes.func.isRequired,
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchForm: (values) => {
            dispatch(updateUser(values));
        },
    };
};

const enhance = compose(
    translate,
    connect(
        null,
        mapDispatchToProps,
    ),
    fetchResourceById({
        resource: 'users',
        action: fetchUser,
    }),
);

export default enhance(UsersEditContainer);



// WEBPACK FOOTER //
// ./src/pages/users/edit/UsersEditContainer.js